import React, { CSSProperties } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import { useLayoutContext } from '../../context/LayoutContext';
import useUserAvatar from '../../../UserAvatar/useUserAvatar';
import AccountDropdownMenu from '../../../AccountDropdownMenu';
import createSignoutProps from '../../../../lib/createSignoutProps';
import NavigationHeader from './NavigationHeader';
import NavigationTabs from './NavigationTabs';
import NavCreateButton from './NavCreateButton';
import Command from '../../../debug/Command';
import Debug from '../../../debug/Debug';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()(theme => ({
  root: {
    height: '100%',
    backgroundColor: palette.gray_1100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
  userProfile: {
    marginBottom: '12px',
    alignSelf: 'start',
    marginLeft: '4px',
    position: 'fixed',
    bottom: 8,
    left: 11,
    zIndex: theme.zIndex.drawer + 1,
  },
  tabs: {
    width: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    scrollbarGutter: 'auto',
    ...(theme.mixins.scrollBar as CSSProperties),
  },
  header: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  createButton: {
    width: '100%',
    paddingTop: theme.spacing(2),
  },
}));

/**
 * This component is the container for all left rail content including:
 * Header, navigation tabs, user account menu
 */

const StudioNavigation = () => {
  const userData = useUserAvatar();
  const signoutProps = createSignoutProps();
  const { isLeftRailOpen } = useLayoutContext();
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Box className={classes.header}>
        <NavigationHeader />
      </Box>
      <Box className={classes.createButton}>
        <NavCreateButton isLeftRailOpen={isLeftRailOpen} />
      </Box>
      <Box className={classes.tabs}>
        <NavigationTabs isLeftRailOpen={isLeftRailOpen} />
      </Box>
      <Box className={classes.userProfile}>
        <AccountDropdownMenu
          email={userData.email}
          userName={userData.name}
          subscriptionName={userData.subscriptionName}
          showUpgrade={userData.showUpgrade}
          userId={userData.userId}
          userInitials={userData.initials}
          onUpgrade={userData.onUpgrade}
          onSignOut={signoutProps.onClick}
        />
      </Box>
      <Debug>
        <Command />
      </Debug>
    </div>
  );
};

export default StudioNavigation;
